<h2 mat-dialog-title>{{ 'PHOTO.REMOVE_MODAL.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>
    {{ 'PHOTO.REMOVE_MODAL.CONTENT' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="accept(false)">
    {{ 'PHOTO.REMOVE_MODAL.KEEP' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="accept(true)">
    {{ 'PHOTO.REMOVE_MODAL.REMOVE' | translate }}
  </button>
</mat-dialog-actions>
